export const MetricConfigurationsConstants = {
  STARTERBOX_HEADER: "Organize your data",
  STARTERBOX_EXPLAIN:
    "Categorize unorganized behavior codes, exit codes, course subjects and more to see meaningful patterns across your schools.",
  STARTERBOX_ACTION: "Learn More",
};
